// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"8a88ddc4","897":"107006bd"}[chunkId] + ".chunk.js";
};